import ViewBase from "../../../../framework/core/mvvm/view_base";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import GameUtil from "../../../../utility/game_util";
import ShopItemCompent from "./shopItem";
import LoaclStorage from "../../../../manager/local_storage";
const { ccclass, property } = cc._decorator;

@ccclass
export default class ShopView extends ViewBase {
    @property(cc.Node)
    shopItem:cc.Node = null

    @property(cc.Node)
    itemGrid:cc.Node = null

    @property(cc.SpriteFrame)
    iconAtlas:cc.SpriteFrame[] = []

    @property(cc.ScrollView)
    itemScrollView:cc.ScrollView = null

    @property(cc.Label)
    goldCount:cc.Label = null

    @property(cc.Label)
    daibiCount:cc.Label = null

    @property(cc.Node)
    noItemTips:cc.Node = null

    @property(cc.Node)
    btnNode:cc.Node[] = []

    @property(cc.Node)
    btnPayNode:cc.Node[] = []

    btnNameByQgNode = []
    btnLeftNameByQgNode = []
    payIdByName = []
    curShowData = null
    curIsBottom = null
    curPayName = ""
    shopItemCom = []

    payCodeByName = {
        "APPLE_STORE":"PayBtn",
        "GOOGLE_PLAY":"PayBtn",
        "1":"SMSPayBtn",
        "331":"BankPayBtn",
        "332":"LinePayBtn",
        "340":"Money2PayBtn",
        "342":"Money1PayBtn",
        "344":"7PayBtn",
    }

    onLoad(){
        for (let index = 0; index < this.btnNode.length; index++) {
            const btnNode = this.btnNode[index];
            this.btnNameByQgNode[btnNode.name] = cc.find("Background", btnNode)
        }
    }

    initPayBtn(payData, callBack){
        let btnNodes = []
        let isFrist = true
        this.curPayName = LoaclStorage.getString("LAST_SHOP_KEY")
        for (let index = 0; index < this.btnPayNode.length; index++) {
            const btnNode = this.btnPayNode[index];
            this.btnLeftNameByQgNode[btnNode.name] = cc.find("Background", btnNode)
            btnNodes[btnNode.name] = btnNode
            btnNode.active = false
        }

        for (let index = 0; index < payData.length; index++) {
            const element = payData[index];
            if (this.payCodeByName.hasOwnProperty(element.payChannelCode)){
                let btnName = this.payCodeByName[element.payChannelCode] 
                btnNodes[btnName].active = true
                this.payIdByName[btnName] = element.id
            }
            
        }
        let firName = null
        for (let index = 0; index < this.btnPayNode.length; index++) {
            const btnNode = this.btnPayNode[index];
            if (btnNode.active){
                if (this.curPayName == btnNode.name){
                    isFrist = false
                    break
                }
                if (firName == null){
                    firName = btnNode.name
                }
            } 

        }
        if (isFrist){
            isFrist = false
            this.curPayName = firName
        }

        if (callBack != null){
            callBack(this.curPayName)
        }
           

    }

    //更新按钮选择显示
    updateBtnChoose(btnName, isPayBtn = false){
        let btnList = isPayBtn ? this.btnLeftNameByQgNode : this.btnNameByQgNode
        for (const key in btnList) {
            if (btnList.hasOwnProperty(key)) {
                const btnQgNode = btnList[key];
                if (isPayBtn){
                    btnQgNode.active = key != btnName
                    // if (this.curPayName != btnName){
                         this.curPayName = btnName
                        this.updateShopItem(this.curShowData, this.curIsBottom)
                    //}
                    
                }
                else{
                    btnQgNode.active = key == btnName
                }
            }
        }
    }

    setCurrencyData(gold: number, daibi:number) {
        this.goldCount.string = GameUtil.currencyFormatting(gold);
        this.daibiCount.string = GameUtil.currencyFormatting(daibi);
    }

    updateShopItem(data, isBottom){
        this.curShowData = data
        this.curIsBottom = isBottom
        let dataCount = data != null ? data.length : 0
        let curIndex = 0
        for (let index = 0; index < dataCount; index++) {
            const element = data[index];
            if (this.shopItemCom[curIndex] == null){
                let obj = cc.instantiate(this.shopItem)
                this.itemGrid.addChild(obj)
                this.shopItemCom[curIndex] = obj.getComponent(ShopItemCompent)
            }
            let isTure =  this.shopItemCom[curIndex].setData(this, element, curIndex, this.payIdByName[this.curPayName])
            if (isTure){
                curIndex += 1
            }

        }
        if (this.shopItemCom.length > curIndex){
            for (let index = curIndex; index < this.shopItemCom.length; index++) {
                this.shopItemCom[index].setData(this, null)
            }
        }
        this.noItemTips.active = (dataCount == 0)
        this.itemScrollView.scrollToTop(0)

        // if (isBottom && dataCount > 5){
        //     this.itemScrollView.scrollToBottom(0)
        // }
        // else{
        //     this.itemScrollView.scrollToTop(0)
        // }
    }

}
